import React from "react";
import PropTypes from "prop-types";
import SellOutNiveaDesktop from "../SellOutNivea/SellOutNiveaDesktop";

function SellOutEucerin({ app, config }) {
  return (
    <SellOutNiveaDesktop
      app={app}
      config={config}
      pdvTitle="Sell Thru Eucerin + PDV"
      pdvObjectId="bd1a1487-7e3b-477f-95f8-583a76b12523"
      resultadosObjectId="305727e7-b505-4c1c-9374-f9063e8e9238"
      rankingSegmentoObjectId="1af330d2-a8c7-4d47-92dd-08ab37ba0e4f"
      rankingUFObjectId="5707159e-6f8f-4f08-bb28-605687693402"
      rankingCidadeObjectId="e99719c7-931a-4721-88b9-f98c4e4b8325"
    />
  );
}

SellOutEucerin.defaultProps = {
  app: null,
  config: {},
};

SellOutEucerin.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default SellOutEucerin;
